'use es6';

import DevHelpers from 'ContentEditorUI/devHelpers';
class BlogEditorDevHelpers extends DevHelpers {
  perAppLogToConsole() {
    // Blog specific dev helper info...
  }
}
export default function setupDevHelpers({
  eventBus
}) {
  window.hubspot.ContentEditorUI.devHelpers = new BlogEditorDevHelpers({
    eventBus
  });
}